import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class ConfirmService extends Service {
  // Defaults
  @tracked showPrompt = false;
  @tracked options = {};
  @tracked title;
  @tracked message;
  @tracked resolve = () => {};

  // Functions
  ask(title, message, options) {
    this.options = options;
    this.title = title;
    this.message = message;
    this.showPrompt = true;

    return new Promise((resolve) => {
      this.resolve = resolve;
    });
  }

  reset() {
    this.showPrompt = false;
    this.resolve = () => {};
  }

  // Actions
  confirm = (ok = true) => {
    this.resolve(ok);
    this.reset();
  };

  cancel = () => {
    this.resolve(false);
    this.reset();
  };
}
